export function precoProdutosInRequest(params = {}) {
  return {
    type: '@precoproduto/PRODUTOS_IN_REQUEST',
    payload: { params },
  };
}

export function findPrecoProduto(idproduto) {
  return {
    type: '@precoproduto/FIND_PRODUTO',
    payload: { idproduto },
  };
}

export function failedRequest() {
  return {
    type: '@precoproduto/FAILED_REQUEST',
  };
}

export function storePrecoProduto(precoproduto, params) {
  return {
    type: '@precoproduto/STORE_PRODUTO',
    payload: { precoproduto, params },
  };
}

export function successRemove(params) {
  return {
    type: '@precoproduto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function successInRequest(
  precosprodutos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@precoproduto/SUCCESS_IN_REQUEST',
    payload: { precosprodutos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(precoproduto) {
  return {
    type: '@precoproduto/SUCCESS_REQUEST',
    payload: { precoproduto },
  };
}

export function recordFiltering(params) {
  return {
    type: '@precoproduto/RECORD_FILTERING',
    payload: { params },
  };
}
